export function isValidEngine(engine?: string): engine is string {
  // The VW api sometimes also returns "-" as an engine.
  // We'll try to safeguard against it and similar values by checking for a
  // sensible string length.

  return Boolean(engine && engine.length > 2);
}
